import { Link } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';
import React from 'react';
import ComingSoonImage from '../../images/location-coming-soon.jpg';
import ArrowRightIcon from '../atoms/ArrowRightIcon';
import Button from '../atoms/Button';
import Florida from '../atoms/Florida';
import Image from '../atoms/Image';
import OpeningHours from '../atoms/OpeningHours';
import Parrot from '../atoms/Parrot';
import RunningDonutClock from '../atoms/RunningDonutClock';
import TexasStar from '../atoms/TexasStar';
import { format, parse } from 'date-fns';

interface LocationCardProps {
  name: string;
  slug: string;
  illustration?: string;
  photo?: {
    localFile: any;
    altText: string;
  };
  place: any;
  timezone: string;
  address: string;
  comingSoon: boolean;
  comingSoonDate?: string;
}

const LocationCard = ({
  name,
  slug,
  illustration,
  photo,
  place,
  timezone,
  address,
  comingSoon,
  comingSoonDate,
}: LocationCardProps) => {
  return (
    <div className="lg:max-w-[480px] mb-16 flex-shrink-0">
      <Link
        to={`/locations/${slug}`}
        className="relative block"
        aria-label={name}
      >
        {illustration === 'TexasStar' && (
          <TexasStar className="absolute z-10 w-auto h-32 -left-20 -top-16" />
        )}
        {illustration === 'Florida' && (
          <Florida className="absolute z-10 w-auto h-32 -right-14 -top-12" />
        )}
        {illustration === 'Parrot' && (
          <Parrot className="absolute z-10 w-auto h-20 -left-20 -top-12" />
        )}
        {illustration === 'RunningDonutClock' && (
          <RunningDonutClock className="absolute z-10 w-auto h-36 -right-16 -bottom-8" />
        )}
        {comingSoon ? (
          <img
            src={ComingSoonImage}
            alt="Location coming soon"
            className="w-full h-auto mb-8"
          />
        ) : (
          <div className="inline-block mb-8 overflow-hidden">
            <Image
              image={getImage(photo.localFile)}
              alt={photo.altText}
              className="w-full h-auto transition-all duration-1000 hover:scale-110 hover:transform aspect-24/16"
            />
          </div>
        )}
      </Link>
      <h3 className="pb-4 mb-0 border-b border-faux-light u-h3">
        <Link
          to={`/locations/${slug}`}
          className="flex items-center justify-between w-full"
        >
          <span>{name}</span>
          <ArrowRightIcon className="w-5 h-auto" />
        </Link>
      </h3>
      <div className="flex flex-col justify-between py-4 border-b md:flex-row text-navy-blue border-faux-light">
        <div className="pb-4 pr-2 md:pb-0">
          {!comingSoon ? (
            <div
              className="text-xl"
              dangerouslySetInnerHTML={{
                __html: address ? `${address}`.replace('\n', '<br />') : '',
              }}
            />
          ) : (
            <div className="text-xl">
              Subscribe for grand opening details and be automatically added for
              VIP events + early access.
            </div>
          )}
        </div>
        {!comingSoon ? (
          <div className="flex-shrink-0 pt-4 text-xl border-t md:text-right md:border-t-0 md:border-l border-faux-light md:pt-0 md:pl-7">
            <OpeningHours place={place} timezone={timezone} />
          </div>
        ) : (
          <div className="md:w-[180px] flex-shrink-0 border-t md:border-t-0 md:border-l border-faux-light pt-4 md:pt-0 md:text-right text-xl font-bold pl-2">
            {comingSoonDate
              ? `Celebrate our Grand Opening ${format(
                  parse(comingSoonDate, 'dd/MM/yyyy', new Date()),
                  'MMMM do'
                )}!`
              : 'coming soon!'}
          </div>
        )}
      </div>
      <div className="mt-6">
        <Button
          to={
            comingSoon ? `/locations/${slug}` : 'https://order.saltydonut.com/'
          }
          variant="default"
        >
          {comingSoon ? 'Subscribe' : 'Order now'}
        </Button>
      </div>
    </div>
  );
};

export default LocationCard;
